import { PageId } from 'constants/pages'

export const enum PageIdStylioCapsen {
  AGE_CAPSEN = PageId.AGE_CAPSEN,
  URGE_CAPSEN = PageId.URGE_CAPSEN,
  HAIR_COLOR_CAPSEN = PageId.HAIR_COLOR_CAPSEN,
  EYES_COLOR_CAPSEN = PageId.EYES_COLOR_CAPSEN,
  JEWELRY_CAPSEN = PageId.JEWELRY_CAPSEN,
  BODY_SHAPE_CAPSEN = PageId.BODY_SHAPE_CAPSEN,
  STYLIO_TO_HELP_CAPSEN = PageId.STYLIO_TO_HELP_CAPSEN,
  TALL_CAPSEN = PageId.TALL_CAPSEN,
  WEIGHT_CAPSEN = PageId.WEIGHT_CAPSEN,
  URGE_2_CAPSEN = PageId.URGE_2_CAPSEN,
  SHOPPING_CAPSEN = PageId.SHOPPING_CAPSEN,
  STYLE_MOST_MATTERS_CAPSEN = PageId.STYLE_MOST_MATTERS_CAPSEN,
  FEEL_ABOUT_CAPSEN = PageId.FEEL_ABOUT_CAPSEN,
  PERCENTAGE_CAPSEN = PageId.PERCENTAGE_CAPSEN,
  FAVORITE_COLORS_CAPSEN = PageId.FAVORITE_COLORS_CAPSEN,
  LIKE_OR_DISLIKE_12_CAPSEN = PageId.LIKE_OR_DISLIKE_12_CAPSEN,
  LIKE_OR_DISLIKE_13_CAPSEN = PageId.LIKE_OR_DISLIKE_13_CAPSEN,
  LIKE_OR_DISLIKE_14_CAPSEN = PageId.LIKE_OR_DISLIKE_14_CAPSEN,
  LIKE_OR_DISLIKE_15_CAPSEN = PageId.LIKE_OR_DISLIKE_15_CAPSEN,
  LIKE_OR_DISLIKE_16_CAPSEN = PageId.LIKE_OR_DISLIKE_16_CAPSEN,
  LIKE_OR_DISLIKE_17_CAPSEN = PageId.LIKE_OR_DISLIKE_17_CAPSEN,
  LIKE_OR_DISLIKE_18_CAPSEN = PageId.LIKE_OR_DISLIKE_18_CAPSEN,
  LIKE_OR_DISLIKE_19_CAPSEN = PageId.LIKE_OR_DISLIKE_19_CAPSEN,
  STYLES_FEEL_LIKE_YOU_CAPSEN = PageId.STYLES_FEEL_LIKE_YOU_CAPSEN,
  URGE_4_CAPSEN = PageId.URGE_4_CAPSEN,
  BRAND_CAPSEN = PageId.BRAND_CAPSEN,
  FIND_NEW_CLOTHES_CAPSEN = PageId.FIND_NEW_CLOTHES_CAPSEN,
  NOTHING_TO_WEAR_CAPSEN = PageId.NOTHING_TO_WEAR_CAPSEN,
  OLD_CLOTHES_CAPSEN = PageId.OLD_CLOTHES_CAPSEN,
  COMBINE_CLOTHES_CAPSEN = PageId.COMBINE_CLOTHES_CAPSEN,
  OPTIMIZE_BUDGET_CAPSEN = PageId.OPTIMIZE_BUDGET_CAPSEN,
  URGE_3_CAPSEN = PageId.URGE_3_CAPSEN,
  PREPARE_FLOW_CAPSEN = PageId.PREPARE_FLOW_CAPSEN,
  EMAIL_CAPSEN = PageId.EMAIL_CAPSEN,
  EMAIL_CONSENT_CAPSEN = PageId.EMAIL_CONSENT_CAPSEN,
  SUBSCRIPTIONS_CAPSEN = PageId.SUBSCRIPTIONS_CAPSEN,
  CANCEL_OFFER_CAPSEN = PageId.CANCEL_OFFER_CAPSEN,
  SUB_UPSELL_CAPSEN = PageId.SUB_UPSELL_CAPSEN,
  UPSELL_CAPSEN = PageId.UPSELL_CAPSEN,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_CAPSEN = PageId.DOWNLOAD_CAPSEN,
}
